import { Flex } from 'antd';
import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Typography } from 'tfc-components';

import logoEvol from 'assets/images/logo_evol.png';
import thumbnailLogin from 'assets/images/thumbnail_login.png';
import Button from 'components/atoms/Button';
import Image from 'components/atoms/Image';
import LoginSocials from 'components/organisms/LoginSocials';

export type FormReturnTypes = {
  email: string;
  password: string;
  rememberAccount: boolean;
};

interface LoginFormProps { }

const LoginForm: React.FC<LoginFormProps> = () => (
  <div className="t-login form-wrapper">
    <Container fluid>
      <Flex justify="space-between">
        <Image
          ratio="205x42"
          src={logoEvol}
          alt="Logo Ask2Auto"
          size="contain"
          className="t-login_logo"
        />
        <Button variant="outline">Contact Us</Button>
      </Flex>
      <Flex vertical align="center" className="t-login_content">
        <Image
          ratio="447x365"
          src={thumbnailLogin}
          alt="Login Ask2Auto"
          className="t-login_thumbnail"
        />
        <Typography.Heading
          fontweight="600"
          textStyle="center"
          extendClasses="t-login_content_heading"
        >
          Login to Ask2Auto
        </Typography.Heading>
        <LoginSocials />
        <div className="t-login_content_terms">
          By continuing, you agree to our
          {' '}
          <Link to="/terms-and-conditions" target="_blank" className="t-login_content_link">
            Terms of Service, Privacy Policy
          </Link>
          {' '}
          and
          {' '}
          <Link to="/privacy-policy" target="_blank" className="t-login_content_link">
            Data Protection Agreement.
          </Link>
        </div>
      </Flex>
    </Container>
  </div>
);

export default LoginForm;
